module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_c('b', [_vm._v("CREDITS")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Executive Editor")]), _vm._v(" "), _c('br'), _vm._v("Bob Elliott")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Senior Development Editor")]), _vm._v(" "), _c('br'), _vm._v("Kevin Kent")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Production Editor")]), _vm._v(" "), _c('br'), _vm._v("Pamela Hanley")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Copy Editor")]), _vm._v(" "), _c('br'), _vm._v("Nancy Rapoport")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Editorial Manager")]), _vm._v(" "), _c('br'), _vm._v("Mary Beth Wakefield")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Production Manager")]), _vm._v(" "), _c('br'), _vm._v("Tim Tate")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Vice President and Executive")]), _vm._v(" "), _c('br'), _c('b', [_vm._v("Group Publisher")]), _vm._v(" "), _c('br'), _vm._v("Richard Swadley")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Vice President and Executive")]), _vm._v(" "), _c('br'), _c('b', [_vm._v("Publisher")]), _vm._v(" "), _c('br'), _vm._v("Joseph B. Wikert")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Project Coordinator")]), _vm._v(" "), _c('br'), _vm._v("Ryan Steffen")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Graphics and Production Specialists")]), _vm._v(" "), _c('br'), _vm._v("Denny Hager "), _c('br'), _vm._v("Jennifer Heleine "), _c('br'), _vm._v("Stephanie D. Jumper "), _c('br'), _vm._v("Alicia B. South")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Quality Control Technician")]), _vm._v(" "), _c('br'), _vm._v("Joe Niesen")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Media Development Coordinator")]), _vm._v(" "), _c('br'), _vm._v("Laura Atkinson")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Proofreading and Indexing")]), _vm._v(" "), _c('br'), _vm._v("TECHBOOKS Production Services")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-538cbcee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wyso_9780470446539_oeb_fm1_r1.vue
// module id = 69
// module chunks = 0